const state = {
  staticPackageType: 'weekly',
  chooseRegionArr: [],
  totalInfo: { total: 0 },
  staticCountryInfo: []
};

const mutations = {
  setCart(state, payload) {
    state.staticPackageType = payload.staticPackageType;
    state.chooseRegionArr = payload.chooseRegionArr;
    state.totalInfo = payload.totalInfo;
    state.staticCountryInfo = payload.staticCountryInfo;
  },
  updateChooseRegionArr(state, payload) {
    state.chooseRegionArr = payload;
  },
  updateTotalInfo(state, payload) {
    state.totalInfo = payload;
  },
  updateStaticCountryInfo(state, payload) {
    state.staticCountryInfo = payload;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
